import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {keysWithThousandsSeparator, searchFaqsConfig} from './config.js'

const BASE_CLASS = 'mt-PanelSearchFaqs'
const ITEM_CLASS = `${BASE_CLASS}-item`
const QUESTION_CLASS = `${ITEM_CLASS}Question`
const ANSWER_CLASS = `${ITEM_CLASS}Answer`

const PanelSearchFaqs = ({searchFaqs = [], semanticDescriptor}) => {
  const {i18n} = useContext(Context)

  const faqsList = searchFaqsConfig
    .map(faqItemConfig => {
      const {value} = searchFaqs.find(faqElement => faqElement.type === faqItemConfig.key) || {}
      const hasExtendedData = Boolean(value)

      const translatedValue = value && keysWithThousandsSeparator.includes(faqItemConfig.key) ? i18n.n(value) : value

      const question = i18n.t(`SEARCH_FAQS.${faqItemConfig.question}`, {
        semanticDescriptor
      })

      const answer = i18n.t(`SEARCH_FAQS.${faqItemConfig.answer}`, {
        value: translatedValue
      })

      return hasExtendedData
        ? {
            ...faqItemConfig,
            question,
            answer
          }
        : null
    })
    .filter(Boolean)

  return faqsList && semanticDescriptor ? (
    <ul className={BASE_CLASS}>
      {faqsList.map(faqItem => {
        return (
          <li key={faqItem.key} className={ITEM_CLASS}>
            <p className={QUESTION_CLASS}>{faqItem.question}</p>
            <p className={ANSWER_CLASS}>{faqItem.answer}</p>
          </li>
        )
      })}
    </ul>
  ) : null
}

PanelSearchFaqs.displayName = 'PanelSearchFaqs'
PanelSearchFaqs.propTypes = {
  searchFaqs: PropTypes.array.isRequired,
  semanticDescriptor: PropTypes.string.isRequired
}

export default PanelSearchFaqs
